// extracted by mini-css-extract-plugin
export var actions = "_l5-d";
export var benefitCard = "_l5-a";
export var benefitIcon = "_l5-b";
export var benefitLabel = "_l5-c";
export var benefits = "_l5-9";
export var bodyText = "_l5-8";
export var closeButton = "_l5-2";
export var content = "_l5-3";
export var eyebrow = "_l5-4";
export var heading = "_l5-5";
export var image = "_l5-f";
export var imagePanel = "_l5-e";
export var modal = "_l5-0";
export var shell = "_l5-1";
export var title = "_l5-6";
export var titleOffer = "_l5-7";